<template>
  <div className="RequirementShow">
    <div  class="date-box">
      <div style="display: inline-block;">关键词: <span v-html="'\u00a0\u00a0'"></span></div>
              <div style="display: inline-block;color:darkgreen"  v-for = "tag in dynamicTags">
                {{tag}}<span v-html="'\u00a0\u00a0'"></span>
              </div>
    </div>
    <div style=" text-align: right;padding:2% 40% 10px 0"> <el-button @click="open" v-if="type!=3 && isBusiness==true">提交审核</el-button></div>
    <div style="padding:2% 40% 0 10px" v-if="type==4" class="advice">{{'审核建议: '+advice}}



    </div><hr v-if="type==4">

    <div style="width: 980px;margin: auto;">
      <table id="customers">
        <tr><td class="first">单位名称</td><td>{{companyName}}</td></tr>
        <tr><td class="first">单位标识</td><td>{{companyId}}</td></tr>
        <tr><td class="first">需求项目名称</td><td>{{name}}</td></tr>
        <tr><td class="first">意向合作方式</td><td>{{manner}}</td></tr>
        <tr><td class="first">本项目拟投入资金</td><td>{{needMoney+'万'}}</td></tr>
        <tr><td class="first">联系人</td><td>{{contact}}</td></tr>
        <tr><td class="first">联系电话</td><td>{{contactNumber}}</td></tr>
        <tr><td class="first">联系地址</td><td>{{contactAddress}}</td></tr>
        <tr><td class="first">发布时间</td><td>{{date}}</td></tr>
      </table>
      <div className="title-box" >需求主要内容：</div>
      <div v-html="content" className="details-box"></div>
    </div>
  </div>
</template>

<script>
import time from "@/core/time";
import {ElLoading} from "element-plus";

export default {
  created() {
    this.$request.get("/account/getUserInfo").then(res=>{
      if(res.obj==null){
        this.logout();
      }else{
        this.isManager = res.obj.isManager;
        this.isBusiness = res.obj.isBusiness;
      }
      console.log('userInfo',res.obj);
      console.log('12349')

    });

  },

  mounted() {
    this.id = this.$route.query.id;
    this.filter();
    this.tagInit();
  },

  watch: {
    $route(to, from) {
      window.location.reload(); //监测到路由发生跳转时刷新一次页面
    },
  },
  data() {
    return {
      name:'',
      content:'',
      id:'',
      advice:'空',
      type:'',
      manner:'',
      companyName:'',

      tableData:[],
      dynamicTags: [],

      editor: ClassicEditor,
      needMoney:'',
      contact:'',
      contactAddress:'',
      contactNumber:'',
      companyId:'',
      fileList: [],
      isManager:false,
      //是否是商家
      isBusiness:false,

    }
  },
  methods: {
    tagInit(){
      if(this.id == undefined)
      {
        return 2;
      }
      let data = {
        id:this.id,
        type:2,
      }
      let url = '/keyword/getKeywordByAchiId';
      this.$request.post(url,data).then(data =>{
        console.log("1111111111111111111111"+data);
        for (var i = 0; i < data.obj.length; i++) {
          this.dynamicTags[i] = data.obj[i].name;
        }

      })
    },
    open() {
      this.$confirm('是否确认通过？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'

      })
          .then(() => {
            this.$router.push({
              path:'/myRequirement',
            })
            let data = {
              type:2,
              id:this.id,
            };
            this.$request.post('/arRequirement/submitCheckRequirement',data).then(data => {
              console.log("success!");
            })
            this.$message({
              type: 'success',
              message: '保存修改'
            });
          })
          .catch(action => {
            this.$message({
              type: 'info',
              message:'取消'
            })
          });

    },
    filter() {
      // let data = {
      //   id:this.id,
      // }
      let loadingInstance = null;
      loadingInstance = ElLoading.service({fullscreen: true});
      this.$request.post('/arRequirement/selectrequirement', this.id).then(data => {
        // console.log(data)
        // //debugger
        this.name = data.obj.arRequirement.name;
        this.advice = data.obj.arRequirement.advice;
        if(this.advice==null||this.advice=='') this.advice='空'
        this.content = data.obj.arRequirement.content;
        this.needMoney= data.obj.arRequirement.needMoney
        this.manner=  data.obj.arRequirement.manner
        this.type= data.obj.arRequirement.type
        this.contact= data.obj.arRequirement.contact
        this.contactAddress= data.obj.arRequirement.contactAddress
        this.contactNumber= data.obj.arRequirement.contactNumber
        this.companyId= data.obj.arRequirement.companyId
        this.companyName= data.obj.arRequirement.companyName
        this.date = time.formateDate(data.obj.arRequirement.createdDate);
        loadingInstance.close();
      })
    },
  }
}
</script>

<style lang="less">
#customers {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  .first{
    width: 25%;
  }
}

#customers td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #ddd;}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}
.RequirementShow {
  width: 100%;
  height: 100%;
  .advice{
    //border: 1px solid gray;
    color: red;
  }
  a:link {
    color: black;
    text-decoration: none;
  }

  //未访问
  a:active {
    color: black;
  }

  //激活：红色
  a:visited {
    color: black;
    text-decoration: none;
  }

  //已访问
  a:hover {
    color: black;
    text-decoration: underline;
  }

  //鼠标移近
  .btn-back {
    border: none;
    font-size: 16px;
  }

  .title-box {
    text-align: center;
    font-size: 20px;
    margin: 60px 0 30px 0;
    font-weight: 800;
  }
  .date-box{
    font-size: 16px;
    color: #777777;
    text-align: center;
    padding-bottom: 24px;
  }

  .date-box {
    font-size: 16px;
    color: #777777;
    text-align: center;
    padding-bottom: 48px;
  }

  .details-box {
    margin-top: 25px;
    font-size: 16px;
    line-height: 25px;
    //text-align: center;

    img {
      //vertical-align:middle;
      //border: 1px solid red;
      //margin:auto;
    }

  }

  .file-box {
    margin-top: 40px;
    padding-bottom: 50px;
  }
}
</style>
